import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'
import { TheWestSection } from '@news-mono/common'
import {
    Election,
    FederalElection,
    getElectionId,
    StateElection,
    StaticRoutes,
} from '@news-mono/web-common'
import { createElectorateEmbedPage } from '../embeds/createElectorateEmbedPage'
import { createElectionLandingPage } from './createElectionPage'

/**
 * Creates the routes declarations for a state election.
 */
export const createStateElectionRoutes = (
    election: StateElection,
): StaticRoutes<TheWestSection> => {
    const heading = `${
        election.year
    } ${election.state.toUpperCase()} State Election`

    return {
        [`/politics/${getElectionId(election)}`]: ({
            getAdTargeting,
            store,
        }) => {
            let isLandingPageEnabled = false

            if (election.state === 'wa') {
                isLandingPageEnabled = isFeatureEnabled(
                    toFeatureState(store.getState().toggles),
                    'wa-election-landing-page-route',
                )
            }

            if (!isLandingPageEnabled) {
                return null
            }

            return createElectionLandingPage({
                heading,
                description: 'TODO',
                getAdTargeting,
                election,
            })
        },
        [`/embeds/${getElectionId(election)}/electorate`]: ({
            getAdTargeting,
            store,
        }) => {
            const enableRoute = isFeatureEnabled(
                toFeatureState(store.getState().toggles),
                'election-widget-preview-page',
            )

            if (!enableRoute) {
                return null
            }

            return createElectorateEmbedPage({
                heading: `${heading} Embed`,
                description: 'An embed for the state election electorate.',
                getAdTargeting,
            })
        },
    }
}

/**
 * Creates the route declarations for a federal election.
 */
export const createFederalElectionRoutes = (
    election: FederalElection,
): StaticRoutes<TheWestSection> => {
    const heading = `${election.year} Federal Election`

    return {
        [`/politics/${getElectionId(election)}`]: ({
            getAdTargeting,
            store,
        }) => {
            const isLandingPageEnabled = isFeatureEnabled(
                toFeatureState(store.getState().toggles),
                'federal-election-landing-page-route',
            )

            if (!isLandingPageEnabled) {
                return null
            }

            return createElectionLandingPage({
                heading,
                description: 'TODO',
                getAdTargeting,
                election,
            })
        },
        [`/embeds/${getElectionId(election)}/electorate`]: ({
            getAdTargeting,
            store,
        }) => {
            const enableRoute = isFeatureEnabled(
                toFeatureState(store.getState().toggles),
                'election-widget-preview-page',
            )

            if (!enableRoute) {
                return null
            }

            return createElectorateEmbedPage({
                heading: `${heading} Embed`,
                description: 'An embed for the federal election electorate.',
                getAdTargeting,
            })
        },
    }
}
